import { createSelector } from '@ngrx/store';
import { toSimpleUserTypeTransformer } from '../transformers/transformers';
import { AppState } from '../appState';
import { AuthState } from './auth.reducers';
import { RoleType } from '../types';

const authState = (state: AppState) => state.auth;

const selectLoadSpinnerState = createSelector(authState, (state: AuthState) => state.authSpinner);
const selectAuthUser = createSelector(authState, (state: AuthState) => state.user);
const selectAuthAsSimpleUser = createSelector(authState, (state: AuthState) =>
  state.user ? toSimpleUserTypeTransformer.transform(state.user) : null,
);
const selectTeams = createSelector(authState, (state: AuthState) => state.user?.teams ?? []);
const selectIsFirmUser = createSelector(authState, (state: AuthState) =>
  state.user && state.user.role === RoleType.FIRM_USER ? true : false,
);
const selectIsFirmAdmin = createSelector(authState, (state: AuthState) =>
  [RoleType.BL_ADMIN, RoleType.FIRM_ADMIN].includes(state.user?.role),
);

const selectAuthFirmId = createSelector(authState, (state: AuthState) => state.user?.firm?.id ?? null);

const selectRedirectUrl = createSelector(authState, (state: AuthState) => state.redirectUrl);

const selectAuthFirms = createSelector(authState, (state: AuthState) => state.firms ?? []);

export const AuthSelectors = {
  selectAuthUser,
  selectLoadSpinnerState,
  selectAuthAsSimpleUser,
  selectTeams,
  selectIsFirmUser,
  selectIsFirmAdmin,
  selectAuthFirmId,
  selectRedirectUrl,
  selectAuthFirms,
};
